import { Component, ComponentRef, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import { filter, from, map, toArray } from 'rxjs';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
import { CustomFilterComponent } from '../custom-filter/custom-filter.component';

declare let $: any;


@Component({

  selector: 'app-new-trip-user',

  templateUrl: './new-trip-user.component.html',

  styleUrls: ['./new-trip-user.component.css']

})

export class NewTripUserComponent implements OnInit {

  iUserSystemUser!: number;

  accessSystem: any;

  fullAccessSystem: any;

  assignCarList: any;

  tempAssignCarList: any;

  fullAssignCarList: any;

  countBHas: any;

  lst_UserManager: any = [];

  lst_MobileDomain: any[] = [];

  list_Users: any = [];

  fullUserList: any = [];

  list_schools: any = [];

  list_search = [];

  userActivity: any = [];

  fullUserActivity: any = [];

  lst_Roles: any[] = [];

  iSystemUser_School: string = '';

  bAcssess: any;

  bEditMode: boolean = false;

  filterAddTh: boolean = false;

  bSchool: boolean = false;

  showFilter: boolean = false;

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strUserName: new FormControl('', Validators.required),

  });

  mdl_User: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iSystemUser_User: new FormControl(''),

    strUserName: new FormControl('', Validators.required),

    strFullName: new FormControl('', Validators.required),

    iMobileDomain: new FormControl('', this._other.zeroOrMoreValidator()),

    strMobile_strComment: new FormControl(''),

    strMobile: new FormControl(''),

    strPassword: new FormControl(''), // ???

    strUserPassword: new FormControl(''),

    strUserPassword_: new FormControl(''),

    strSDate: new FormControl(''),

    strEsterakEndDate: new FormControl('', Validators.required),

    iMaxInput: new FormControl('', Validators.required),

    strChart: new FormControl('', this._other.zeroOrMoreValidator()),

    bEnable: new FormControl(false),

    tiConfirmTripLevel: new FormControl(''),

    strSTime: new FormControl(''),

    strETime: new FormControl(''),

    indexUser: new FormControl(''),

  });

  mdl_SMS: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iUserSystemUser: new FormControl(),

    strSMS: new FormControl("", Validators.required),

  });

  mdl_SystemUser_Group: FormGroup = this._formBuilder.group({

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iUserSystemUser: new FormControl(""),

    iSystemUser_Group: new FormControl(""),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    var data = window.localStorage.getItem('menu') as any;

    this.bAcssess = JSON.parse(this._gurd.decrypt(data));

    this.getUser();

    this.getBaseData();

    this.getRoles();

  }

  filter(val: any) {

    this.list_Users = this.fullUserList.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strMobile_strComment.includes(val.value) ||

        el.strUserName.includes(val.value)

    });

    if (this.list_Users.length == 0) {

      this.list_Users = this.fullUserList.filter((el: any) => {

        return el.strUserName.includes(val.value);

      });


    }

  }

  getBaseData = async () => {

    this._other.Showspinner();

    const resp = await axios.post(`GetMobileDomain4Report?iSystemUser=${this._gurd.decrypt(localStorage.getItem("ID")!)}`, {});

    let res = JSON.parse(resp.data);

    if (res.bError) return this._tooltip.showError(res.strError);

    // res.unshift({ iMobileDomain: 0, strComment: 'علیرضا' })

    this.lst_MobileDomain = res;

    // -----------------------------------------------------------------------------

    let res_3 = JSON.parse((await axios.post(`UserManager_Chart_List`, {})).data.toString());

    this._other.nonespinner();
    
    if (res_3.bError) return this._tooltip.showError(res_3.strError);

    this.lst_UserManager = res_3;


  }

  getUser = async () => {

    var model = this._other.stringNumberToNumber({

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iLog_SystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

    })

    this._other.Showspinner();

    // const resp = await axios.post(`GetRadyabUserUsers`, model);
    
    const resp = await axios.post(`GetRadyabUserUsers_New`, model);

    // let res = JSON.parse(resp.data);

    let res = resp.data;

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '113' } });


      return;

    }

    this.list_Users = res;

    this.fullUserList = res;

  }

  newUser = async () => {

    this.mdl_Search.patchValue({

      strUserName: ''

    })

    this.mdl_User.patchValue({

      iSystemUser_User: '',

      strUserName: '',

      strPassword: '',

      strPassword_: '',

      strFullName: '',

      strUserPassword: '',

      strSDate: '',

      strEsterakEndDate: '',

      iMaxInput: '',

      strMobile: '',

      strChart: '',

      iMobileDomain: -1,

      bEnable: false,

      tiConfirmTripLevel: 1,

      strSTime: '07:00',

      strETime: '16:00',

      indexUser: '',

    })

    // در حالت ثبت رمز عبور اجباری است

    this.mdl_User.get('strUserPassword')?.setValidators(Validators.required);

    this.mdl_User.get('strUserPassword_')?.setValidators(Validators.required);

    this.mdl_User.get('strUserPassword')?.updateValueAndValidity();

    this.mdl_User.disable();

    this.bEditMode = false;

    // rerender custom-filter

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    $("#add_Edit_User").modal('show')


  }

  editUserModal(item: any, index: number) {

    this.mdl_Search.patchValue({

      strUserName: item.strUserName

    })

    Object.keys(item).forEach((key) => {

      this.mdl_User.get(key)?.setValue(item[key]);

    })

    this.mdl_User.patchValue({

      indexUser: index,

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iSystemUser_User: item.iSystemUser,

      strSDate: item.strEshterakRegisterDate,

      strPassword: '',

      strUserPassword: '',

      strUserPassword_: '',

    })

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    // در حالت ویرایش رمز عبور اجباری نیست

    this.mdl_User.get('strUserPassword')?.setValidators([]);

    this.mdl_User.get('strUserPassword_')?.setValidators([]);

    this.mdl_User.get('strUserPassword')?.updateValueAndValidity();

    this.mdl_User.enable()

    this.bEditMode = true;

    $("#add_Edit_User").modal('show')


  }

  checkUserName = async () => {

    this.bEditMode = false;

    if (this.mdl_Search.invalid || this.mdl_Search.get('strUserName')?.value.trim() == "") return this._tooltip.showError('لطفا نام کاربری را وارد کنید');

    this._other.Showspinner();

    const resp = await axios.post(`SystemUser_CheckUserName`, this._other.stringNumberToNumber(this.mdl_Search.value));

    this._other.nonespinner();

    let res = JSON.parse(resp.data.toString());

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.mdl_User.controls['strUserName'].setValue(this.mdl_Search.get('strUserName')?.value);

    this.mdl_User.controls['strMobile'].setValue(this.mdl_Search.get('strUserName')?.value);

    this.mdl_User.enable();

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    if (res.length > 0) {

      Object.keys(res[0]).forEach((key) => {

        this.mdl_User.get(key)?.setValue(res[0][key]);

      });

      // در حالت ویرایش رمز عبور اجباری نیست

      this.mdl_User.get('strUserPassword')?.setValue('');

      this.mdl_User.get('strUserPassword')?.setValidators([]);

      this.mdl_User.get('strUserPassword')?.updateValueAndValidity();

      this.mdl_User.get('strUserPassword_')?.setValue('');

      this.mdl_User.get('strUserPassword_')?.setValidators([]);

      this.mdl_User.get('strUserPassword_')?.updateValueAndValidity();

      this.bEditMode = true;

    }

  }

  save_NewUser = async () => {

    const Stime = document.getElementById("Stime") as any;

    const Etime = document.getElementById("Etime") as any;

    this.mdl_User.get('strSTime')?.setValue(Stime.value);

    this.mdl_User.get('strETime')?.setValue(Etime.value);

    if (this.mdl_Search.invalid || this.mdl_User.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید')

    if (this.mdl_User.get('strMobile')?.value && this.mdl_User.get('strMobile')?.value.length < 11) return this._tooltip.showError('لطفا شماره موبایل ر ا به درستی وارد کنید')

    // بررسی رمز عبور در حالت ویرایش 

    if (this.bEditMode) {

      if (this.mdl_User.get('strUserPassword')?.value != '' || this.mdl_User.get('strUserPassword_')?.value != '') {

        if (this.mdl_User.get('strUserPassword')?.value != this.mdl_User.get('strUserPassword_')?.value) return this._tooltip.showError('رمز عبور و تکرار رمز عبور مطابقت ندارند');

      }

    }

    // بررسی رمز عبور در حالت ثیت کاربر

    else {

      if (this.mdl_User.get('strUserPassword')?.value != this.mdl_User.get('strUserPassword_')?.value) return this._tooltip.showError('رمز عبور و تکرار رمز عبور مطابقت ندارند');

    }

    if (Number(this.mdl_User.get('tiConfirmTripLevel')?.value) < 1 || Number(this.mdl_User.get('tiConfirmTripLevel')?.value) > 3) return this._tooltip.showError('سطح تایید سفر اداری باید عددی بین 1 تا 3 باشد');

    // اگر در حالت ثبت بود

    if (!this.bEditMode) {

      this._other.Showspinner();

      const resp = await axios.post(`SystemUser_Save`, this._other.stringNumberToNumber(this.mdl_User.value));

      this._other.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Users.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ذخیره شد');

      $("#add_Edit_User").modal('hide')

    }

    //  اگر در حالت ویرایش بود

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._other.Showspinner();

              let res = JSON.parse((await axios.post(`SystemUser_Edit`, this._other.stringNumberToNumber(this.mdl_User.value))).data.toString());

              this._other.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.list_Users[this.mdl_User.get('indexUser')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#add_Edit_User").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  deleteUser = async (id: any) => {

    $.confirm({

      title: `آیا از حذف این کاربر اطمینان دارید؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            var model = {

              strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

              iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

              iSystemUser4Delete: id

            }

            const resp = await axios.post(`DeleteRadyabUser`, model);

            resp.data = JSON.parse(resp.data);

            this._other.nonespinner();

            if (resp.data.iResult == 0) {

              this._tooltip.showError(resp.data.strError);

              return;

            }

            if (resp.data.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._other.removeLocalStorage();

              this._router.navigate(['login']);

              this._router.navigate(['login'], { queryParams: { error: '114' } });


              return;

            }

            else {

              this._tooltip.showSuccess("با موفقیت حذف شد");

              this.list_Users = this.list_Users.filter((el: any) => {

                return el.iSystemUser != id;

              });

              this.fullUserList = this.list_Users;

            }

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });


  }

  // دسترسی

  access = async (id: any) => {

    this.iUserSystemUser = id;

    var model = this._other.stringNumberToNumber({

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: id

    })

    this._other.Showspinner();

    const resp = await axios.post(`GetRadyabUserAbility`, model);

    this._other.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '115' } });


      return;

    }

    this.accessSystem = JSON.parse(resp.data);

    this.fullAccessSystem = this.accessSystem;

    this.fullAccessSystem = this.accessSystem.sort((a: any, b: any) => {

      var textA = a.bHas;

      var textB = b.bHas;

      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;

    });

    $("#access").modal('show');

  }

  filterAccess(val: any) {

    this.fullAccessSystem = this.accessSystem.filter((el: any) => {

      return el.strComment?.includes(val.value);

    });

  }

  addAllAccess = async () => {

    this._other.Showspinner();

    let strXenotakAbility: string[] = []

    from(this.fullAccessSystem).pipe(map((el: any) => el.strXenotakAbility), toArray()).subscribe({ next: val => strXenotakAbility = val })

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      bAddOrRemove: 1,

      lststrXenotakAbility: strXenotakAbility
    }

    const resp: any = await axios.post(`AddOrRemoveAllUserAbility`, model);

    this._other.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '116' } });


      return;
    }

    else {

      this.accessSystem.forEach((el: any) => {

        el.bHas = 1;

      });

      $('#access').modal('hide')

    }

  }

  removeAllAccess = async () => {

    this._other.Showspinner();

    let strXenotakAbility: string[] = []

    from(this.fullAccessSystem).pipe(map((el: any) => el.strXenotakAbility), toArray()).subscribe({ next: val => strXenotakAbility = val })

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      bAddOrRemove: 0,

      lststrXenotakAbility: strXenotakAbility

    }

    const resp = await axios.post(`AddOrRemoveAllUserAbility`, model);

    this._other.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '117' } });


      return;
    }

    else {

      this.accessSystem.forEach((el: any) => {

        el.bHas = 0;

      });

      $('#access').modal('hide')

    }
  }

  filterAddAccess() {

    this.filterAddTh = !this.filterAddTh;

    if (this.filterAddTh) {

      this.accessSystem = this.fullAccessSystem.filter((el: any) => {

        return el.bHas != 0;

      });

    }

    else {

      this.accessSystem = this.fullAccessSystem;

    }

  }

  addOrRemoveAccess = async (id: any) => {

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      strXenotakAbility: id,

    }

    const resp = await axios.post(`AddOrRemoveUserAbility`, model);

    if (resp.data.iResult == 0) {

      this._tooltip.showError(resp.data.strError);

      return;

    }

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '118' } });


      return;

    }

    else {

      // this.notifyService.showSuccess(resp.data.strError);

    }

  }

  // اختصاص خودرو

  assignCar = async (id: any) => {

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: id
    }

    this.iUserSystemUser = id;

    this._other.Showspinner();

    const resp = await axios.post(`GetRadyabUserMobile`, model);

    this._other.nonespinner();

    if (resp.data.iResult == 0) {

      this._tooltip.showError(resp.data.strError);

      return;

    }

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '119' } });


      return;

    }

    else {

      this.assignCarList = JSON.parse(resp.data);

      this.countBHas = 0;

      this.assignCarList.forEach((element: any) => {

        this.countBHas += element.bHas;

      });

      this.fullAssignCarList = JSON.parse(resp.data);
    }

    this.assignCarList.sort((a: any, b: any) => {

      var textA = a.bHas;

      var textB = b.bHas;

      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;

    });

    $("#carModal").modal('show');


  }

  filterCar(val: any) {

    this.assignCarList = this.fullAssignCarList.filter((el: any) => {

      return el.strFullName.includes(val.value);

    });

    if (this.assignCarList.length == 0) {

      this.assignCarList = this.fullAssignCarList.filter((el: any) => {

        return el.strUnitID.includes(val.value);

      });

    }

    if (this.assignCarList.length == 0) {

      this.assignCarList = this.fullAssignCarList.filter((el: any) => {

        return el.strSystemUser_strMobile.includes(val.value);

      });
    }

    if (this.assignCarList.length == 0) {

      this.assignCarList = this.fullAssignCarList.filter((el: any) => {

        return el.strMobileDomain_strComment.includes(val.value);

      });

    }

  }

  addAllCar = async () => {

    let tempArray: any = [];

    let passingArray: any = [];

    tempArray = this.assignCarList.filter((x: any) => !x.bHas);

    tempArray.forEach((element: any) => {

      passingArray.push(element.strUnitID)

    });

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      lstUnitID: passingArray

    }

    const resp = await axios.post(`AddGroupMobilesFromUser`, model);

    if (resp.data.iResult == 0) {

      this._tooltip.showError(resp.data.strError);

      return;

    }

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '120' } });


      return;

    }

    else {

      this.assignCarList.forEach((el: any) => {

        el.bHas = 1;

      });

    }

  }

  removeAllCar = async () => {

    let tempArray: any = [];

    let passingArray: any = [];

    tempArray = this.assignCarList.filter((x: any) => x.bHas);

    tempArray.forEach((element: any) => {

      passingArray.push(element.strUnitID)

    });

    var model = {

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iUserSystemUser: this.iUserSystemUser,

      lstUnitID: passingArray,

    }

    const resp = await axios.post(`AddGroupMobilesFromUser`, model);

    if (resp.data.iResult == 0) {

      this._tooltip.showError(resp.data.strError);

      return;

    }

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '121' } });


      return;

    }

    else {

      this.assignCarList.forEach((el: any) => {

        el.bHas = 0;

      });

      // this.notifyService.showSuccess(resp.data.strError);

    }

  }

  filterCarMobileDomain(val: any) {

    this.assignCarList = this.fullAssignCarList.filter((el: any) => {

      return el.strMobileDomain_strComment.includes(val.value);

    });

  }

  filterAdd() {

    this.filterAddTh = !this.filterAddTh;

    if (this.filterAddTh) {

      this.assignCarList = this.fullAssignCarList.filter((el: any) => {

        return el.bHas != 0;

      });

    }

    else {

      this.assignCarList = this.fullAssignCarList;

    }


  }

  // ارسال پیامک

  sendSms = async () => {

    if (this.mdl_SMS.invalid) return this._tooltip.showError('لطفا متن پیامک را وارد کنید')

    var model = this.mdl_SMS.value;

    model.iUserSystemUser = this.iUserSystemUser;

    const resp = await axios.post(`SendSMS2MobileUser`, model);

    resp.data = JSON.parse(resp.data);

    if (resp.data.iResult == 0) {

      this._tooltip.showError(resp.data.strError);

      return;

    }

    if (resp.data.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '122' } });


      return;

    }

    else {

      this._tooltip.showSuccess("با موفقیت ارسال شد");

      this.mdl_SMS.controls["strSMS"].setValue("");

    }

  }

  // حوزه خدمتی کاربر

  // حوزه های خدمتی تحت نظارت کاربر

  async getUserSchool(item: any, isSupervision?: 'supervision_service') {

    this._other.Showspinner();

    this.list_schools = [];

    this.iSystemUser_School = item.iSystemUser;

    var model = {

      iSystemUser_School: item.iSystemUser,

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

    }

    let url = !this.bSchool ? 'MobileDomain_ListUserAccess' : 'School_MobileDomain_List';

    url = isSupervision ? 'SystemUser_MobileDomain_List' : url

    let res = JSON.parse((await axios.post(url, model)).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '123' } });


      return;

    }

    this.list_schools = res;

    this.list_search = res;

    if (!isSupervision) {

      $("#defineSchool").modal('show')

    }

    else {

      $("#supervision_service").modal('show')

    }

  }

  async onClickMobileDomain(item: any, index: number) {

    this._other.Showspinner();

    var model = {

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: item.iMobileDomain,

      iUserSystemUser: this.iSystemUser_School,

    }

    let res: any = JSON.parse((await axios.post(`SystemUser_UpdateMobieDomain`, model)).data.toString())

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    $('#defineSchool').modal('hide');

    this.list_Users.filter((el: any) => el.iSystemUser == this.iSystemUser_School)[0].strMobile_strComment = item.strComment

    return this._tooltip.showSuccess('عملیات با موفقیت انجام شد')

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_schools = this.list_search.filter((el: any) => {

        return el.strComment?.includes(search) || el.strCityName?.includes(search)

      })
    }


    else if (search == '') this.list_schools = this.list_search

  }

  // سابقه فعالیت کاربر

  userHistory = async (id: any) => {

    this._other.Showspinner();

    this.userActivity = [];

    var model = {} as any;

    model.iSystemUser = this._gurd.decrypt(localStorage.getItem('ID')!);

    model.strSession = this._gurd.decrypt(localStorage.getItem('Session')!);

    model.iLog_SystemUser = id;

    const resp = await axios.post(`GetRadyabUserLog`, model);

    if (resp.data.ISSessionExpired == true) {

      this._other.removeLocalStorage();

      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '124' } });


      return;

    }

    this.userActivity = JSON.parse(resp.data);

    this.fullUserActivity = JSON.parse(resp.data);

    this._other.nonespinner()

    $("#userActive").modal('show');

  }

  setValue_Filter(event: any, type: 'iMobileDomain' | 'strChart') {

    if (type == 'iMobileDomain') {

      if (!event.iMobileDomain && event.iMobileDomain != 0) {

        this.mdl_User.controls['iMobileDomain'].setValue('')

      }

      else {

        this.mdl_User.controls['iMobileDomain'].setValue(event.iMobileDomain);

        if (this.mdl_User.get('iMobileDomain')?.value == 0) {

        }

      }

    }

    if (type == 'strChart') {

      if (!event.strChart) {

        this.mdl_User.controls['strChart'].setValue('')

      }

      else {

        this.mdl_User.controls['strChart'].setValue(event.strChart);

        if (this.mdl_User.get('strChart')?.value.value == 0) {

        }

      }

    }

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'ثبت و ویرایش کاربران سفر.xlsx');
  }

  // 

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._other.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }
  // گروه کاربری

  getRoles = async () => {

    var model = this._other.stringNumberToNumber({

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

    })

    this._other.Showspinner();

    const resp = await axios.post(`SystemUser_Group_List`, this._other.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    this._other.nonespinner();

    this.lst_Roles = res;


  }

  async getUserGroup(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iUserSystemUser: item.iSystemUser,

      iSystemUser_Group: "",

    })

    $("#Access_Modal").modal('show')

  }

  async selectUserGroup(item: any) {

    this.mdl_SystemUser_Group.patchValue({

      iSystemUser_Group: item.iSystemUser_Group,

    })


    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`SystemUser_SetSystemUser_Group`, this._other.stringNumberToNumber(this.mdl_SystemUser_Group.value))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showSuccess(res.strError);

    this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

    $("#Access_Modal").modal('hide');


  }

  
  addOrRemoveCar = async (id: any) => {
    var model = {
      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),
      iUserSystemUser: this.iUserSystemUser,
      strUnitID: id,
    }
    const resp = await axios.post(`AddOrRemoveMobileFromUser`, model);
    if (resp.data.iResult == 0) {
      this._tooltip.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      // this._router.navigate(['login']);

      this._router.navigate(['login'], { queryParams: { error: '125' } });

      return;
    }
  }



}
